<template>
    <div>
        <div class="modal" id="modal-create-company" role="dialog" dusk="modal-create-company">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-teal text-white font-bold">
                        <div class="w-100 flex justify-between">
                            <div>
                                {{ emailContactMode ? 'Select Contact' : 'Add Company' }}
                            </div>
                            <div v-if="emailContactMode" class="flex justify-end">
                                <div @click="emailContactMode = false; emailContact = false; companyContact = false" class="flex cursor-pointer">
                                    <span class="material-icons">chevron_left</span>
                                    <span>Back</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!emailContactMode" class="modal-body bg-white">
                        <div class="flex flex-row justify-content-between px-4">
                            <div class="mb-3 w-full mr-6">
                                <label class="text-grey-darkest text-sm" for="name"
                                       :class="{'text-red': form.errors.has('name')}">Name</label>
                                <input v-model="form.name" id="contact-name" name="name" maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('name')}" dusk="company-name">
                                <div class="text-red text-sm" v-if="form.errors.has('name')">{{ form.errors.get('name') }}
                                </div>
                            </div>
                            <div class="mb-3 w-full">
                                <label class="text-grey-darkest text-sm" for="address"
                                       :class="{'text-red': form.errors.has('address')}">Address</label>
                                <input v-model="form.address" id="address" name="address" maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('address')}" dusk="company-address">
                                <div class="text-red text-sm" v-if="form.errors.has('address')">{{
                                    form.errors.get('address') }}
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-row justify-content-between px-4">
                            <div class="mb-3 w-full mr-6">
                                <label class="text-grey-darkest text-sm" for="city"
                                       :class="{'text-red': form.errors.has('city')}">City</label>
                                <input v-model="form.city" id="city" name="city" maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('city')}" dusk="company-city">
                                <div class="text-red text-sm" v-if="form.errors.has('city')">{{ form.errors.get('city') }}
                                </div>
                            </div>
                            <div class="mb-3 w-full">
                                <label class="text-grey-darkest text-sm" for="state"
                                       :class="{'text-red': form.errors.has('state')}">State</label>
                                <input v-model="form.state" id="state" title="state" maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('state')}" dusk="company-state">
                                <div class="text-red text-sm" v-if="form.errors.has('state')">{{ form.errors.get('state')
                                    }}
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-row justify-content-between px-4">
                            <div class="mb-3 w-full mr-6">
                                <label class="text-grey-darkest text-sm" for="zip"
                                       :class="{'text-red': form.errors.has('zip')}">Zip</label>
                                <input v-model="form.zip" id="zip" name="zip" maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('zip')}" dusk="company-zip">
                                <div class="text-red text-sm" v-if="form.errors.has('zip')">{{ form.errors.get('zip') }}
                                </div>
                            </div>
                            <div class="mb-3 w-full">
                                <label class="text-grey-darkest text-sm" for="phone"
                                       :class="{'text-red': form.errors.has('phone')}">Phone</label>
                                <input v-model="form.phone" id="phone" title="phone" maxlength="64"
                                       v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('phone')}" dusk="company-phone">
                                <div class="text-red text-sm" v-if="form.errors.has('phone')">{{ form.errors.get('phone')
                                    }}
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-row justify-content-between w-full pl-4 pr-2">
                            <div class="mb-3 w-1/2 mr-6">
                                <label class="text-grey-darkest text-sm" for="fax"
                                       :class="{'text-red': form.errors.has('fax')}">Fax</label>
                                <input v-model="form.fax" id="fax" name="fax" maxlength="64"
                                       v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('fax')}" dusk="company-fax">
                                <div class="text-red text-sm" v-if="form.errors.has('fax')">{{ form.errors.get('fax') }}
                                </div>
                            </div>
                         <div class="mb-3 w-1/2 mr-3">
                                    <label
                                        class="text-grey-darkest text-sm"
                                        for="fax"
                                    >
                                        Company Type
                                    </label>
                                    <multiselect
                                        class="cursor-pointer"
                                        v-model="selectedCompanyType"
                                        :options="companyTypes"
                                        label="code" >
                                    </multiselect>
                            </div>
                        </div>

                        <div class="flex flex-row justify-content-between px-4">
                            <div class="mb-3 w-full flex flex-no-wrap mr-6">
                                <div class="w-4/5">
                                    <label class="text-grey-darkest text-sm" for="contact_name"
                                        :class="{'text-red': form.errors.has('contact_name')}">Contact</label>
                                    <input v-model="form.contact_name" id="contact_name" name="contact_name" maxlength="64"
                                        class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                        :class="{'border-red': form.errors.has('contact_name')}" dusk="company-contact-name">
                                    <div class="text-red text-sm" v-if="form.errors.has('contact_name')">{{
                                        form.errors.get('contact_name') }}
                                    </div>
                                </div>
                                <div class="w-1/5 flex justify-center items-center">
                                    <div class="text-center cursor-pointer table mb-0" dusk="company-contact-email-button"
                                        @click.prevent.stop="emailContactMode = true; companyContact = true">
                                        <i class="fa fa-user fa-2x"></i>
                                        <i class="fa fa-plus-circle text-teal" style="margin-left: -22px"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3 w-full">
                                <label class="text-grey-darkest text-sm" for="contact_cell"
                                       :class="{'text-red': form.errors.has('contact_cell')}">Cell</label>
                                <input v-model="form.contact_cell" id="contact_cell" title="contact_cell" maxlength="64"
                                       v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('contact_cell')}" dusk="company-contact-cell">
                                <div class="text-red text-sm" v-if="form.errors.has('contact_cell')">{{
                                    form.errors.get('contact_cell') }}
                                </div>
                            </div>
                        </div>

                    <div class="flex flex-row justify-content-between px-4">
                            <div class="w-full mr-6">
                                <label class="text-grey-darkest text-sm" for="contact_email"
                                       :class="{'text-red': form.errors.has('contact_email')}">Email</label>
                                <input v-model="form.contact_email" id="contact_email" name="contact_email" maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('contact_email')}" dusk="company-contact-email">
                                <div class="text-red text-sm" v-if="form.errors.has('contact_email')">{{
                                    form.errors.get('contact_email') }}
                                </div>
                            </div>
                            <div class="mb-3 w-full">
                                <label class="text-grey-darkest text-sm" for="contact_title"
                                       :class="{'text-red': form.errors.has('contact_title')}">Title</label>
                                <input v-model="form.contact_title" id="contact_title" name="contact_title"
                                       maxlength="64"
                                       class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"
                                       :class="{'border-red': form.errors.has('contact_title')}" dusk="company-contact-title">
                                <div class="text-red text-sm" v-if="form.errors.has('contact_title')">{{
                                    form.errors.get('contact_title') }}
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-row justify-content-between px-4">
                            <div class="w-1/2 mr-3">
                                <label
                                    class="text-grey-darkest text-sm"
                                >
                                    Contact Type
                                </label>
                                <multiselect
                                    class="cursor-pointer"
                                    v-model="selectedContactType"
                                    :options="contactTypes"
                                    label="code" >
                                </multiselect>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-row justify-content-between px-4 bg-white">
                        <company-custom-fields ref="CompanyCustomFields" base="create" :foundationCustomerAccess="foundationCustomerAccess" :foundationAutoGeneratedAccess="foundationAutoGeneratedAccess" actionSide="project"></company-custom-fields>
                    </div>
                    <div v-if="emailContactMode && companyContact" class="modal-body bg-white">
                        <company-contact-create :masks="this.masks" :symbols="this.symbols" :exchange="this.exchange" ref="CompanyContactForm" @selected="parseContact"></company-contact-create>

                    </div>
                    <div v-if="emailContactMode && emailContact" class="modal-body bg-white">
                        <external-email-contact ref="ExternalEmailContact" :masks="this.masks" :symbols="this.symbols" :exchange="this.exchange" :externalEmailService="externalEmailService" @selected="parseContact"></external-email-contact>

                    </div>
                    <div v-if="!emailContactMode"  class="modal-footer">
                        <button class="btn btn-link" type="reset" data-dismiss="modal">
                            Close
                        </button>
                        <button class="btn btn-success" type="reset" @click="saved" dusk="company-save">
                            Create
                        </button>
                    </div>
                    <div v-if="emailContactMode"  class="modal-footer">
                        <div @click="emailContactMode = false; emailContact = false; companyContact = false" class="flex cursor-pointer mr-2">
                            <span>Close</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Form from "../../utils/form";
import Multiselect from 'vue-multiselect'
import Swal from "sweetalert2";
import ExternalEmailContact from "./external-email-contact";

export default {
    name: 'company-create-modal',
    props:['masks', 'symbols','exchange','externalEmailService', 'foundationCustomerAccess', 'foundationAutoGeneratedAccess'],
    data() {
        return {
            form: new Form({
                name                : '',
                company_types_id    : null,
                address             : '',
                city                : '',
                state               : '',
                zip                 : '',
                phone               : '',
                fax                 : '',
                contact_name        : '',
                contact_cell        : '',
                contact_email       : '',
                contact_title       : '',
                contact_types_id    : null,
                customFieldsData: null,
                foundationCustomerNo: null,
                isFoundationNoFollowupPrimaryKey: false
            }),
            companyTypes:[],
            selectedCompanyType: null,
            contactTypes: [],
            selectedContactType: null,
            emailContactMode: false,
            companyContact: false,
            emailContact: false,
        }
    },

    components:{
        ExternalEmailContact,
        Multiselect
    },

    mounted() {
        this.getCompaniesType();
        this.getContactTypes();
        $('#modal-create-company').on('hidden.bs.modal', () => {
            this.form.reset();
        });
        Bus.$on('openEmailContactExternal', data => {
            this.emailContact= true;
            this.emailContactMode= true;
            this.companyContact= false;
        });
        Bus.$on('openCompanyContactCreate', data => {
            this.companyContact= true;
            this.emailContactMode= true;
            this.emailContact= false;
        });

    },

    methods: {
        open(company_name) {
            this.$refs.CompanyCustomFields.fetchCustomFields();
            $('#modal-create-company').modal('show');
            this.form.name = company_name;
        },

        getCompaniesType(){
             let self = this;
            axios.get(route('api.settings.codes.company-type.index')).then(({data}) => {
                self.companyTypes = data;
                self.companyTypes.push({id:null,code:""})
            });
        },

        getContactTypes() {
            let self = this;
            axios.get(route('api.settings.codes.contact-type.index')).then(({data}) => {
                self.contactTypes = data.filter(x => !x.is_residential);
                self.contactTypes.push({id:null,code:""})
            });
        },

        saved(){
            this.form.post(route('api.company.check')).then((response) => {
                if (response.status == 'error') {
                    Swal.fire({
                        title: 'Company Already Exists',
                        text: "Do you want to create a duplicate company",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'Continue creating!'
                    }).then((result) => {
                        if (result.value) {
                            this.form.post(route('api.company.contact.check', {company: 0, fromWhere: 'company'})).then((responseData) => {
                                if (responseData.status == 'error') {
                                    Swal.fire({
                                        title: 'Company Contact Already Exists',
                                        text: "Do you want to create a duplicate contact",
                                        type: 'warning',
                                        showCancelButton: true,
                                        confirmButtonColor: '#01B1AF',
                                        confirmButtonText: 'Continue creating!'
                                    }).then((result) => {
                                        if (result.value) {
                                            this.savedAfterCheck();
                                        }else{
                                            return false
                                        }
                                    });
                                }else{
                                    this.savedAfterCheck();
                                }
                            });
                        }else{
                            return false;
                        }
                    });
                }else{
                    this.form.post(route('api.company.contact.check', {company: 0, fromWhere: 'company'})).then((res) => {
                        if (res.status == 'error') {
                            Swal.fire({
                                title: 'Company Contact Already Exists',
                                text: "Do you want to create a duplicate contact",
                                type: 'warning',
                                showCancelButton: true,
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'Continue creating!'
                            }).then((result) => {
                                if (result.value) {
                                    this.savedAfterCheck();
                                }else{
                                    return false
                                }
                            });
                        }else{
                            this.savedAfterCheck();
                        }
                    });
                }
            });
        },

        savedAfterCheck() {
            let self = this;
            self.form.customFieldsData = self.$refs.CompanyCustomFields.form;

            if(self.foundationCustomerAccess) {
                self.form.post(route('api.company.check-foundation-customer-scenarios')).then((data) => {
                    if(data.pass) {
                        if(data.foundationCustomerNo) {
                            self.form.foundationCustomerNo = data.foundationCustomerNo;
                            self.form.isFoundationNoFollowupPrimaryKey = data.isFollowupPrimaryKey;
                            Swal.fire({
                                title: 'Foundation',
                                text: "Note: If a record exists with the same customer # or email address on Foundation, this will update the existing record. If neither of these exist on Foundation, a new customer record will be created.",
                                type: 'info',
                                showCancelButton: true,
                                confirmButtonColor: '#01B1AF',
                                confirmButtonText: 'Confirm'
                            }).then((result) => {
                                if (result.value) {
                                    self.finalSaveDataRequest();
                                }
                            });
                        }
                        else {
                            self.finalSaveDataRequest();
                        }
                    }
                    else {
                        self.form.foundationCustomerNo = null;
                        self.form.isFoundationNoFollowupPrimaryKey = false;
                        Swal.fire({
                            title: 'Error',
                            text: data.message,
                            type: 'error',
                            showCancelButton: false,
                            confirmButtonColor: '#01B1AF',
                            confirmButtonText: 'OK!',
                            closeOnConfirm: false,
                        });
                    }
                }).catch((error) => {
                    self.form.foundationCustomerNo = null;
                    self.form.isFoundationNoFollowupPrimaryKey = false;
                });
            }
            else {
                self.finalSaveDataRequest();
            }
        },

        parseContact(contact) {
            this.emailContactMode       = false;
            this.companyContact= false;
            this.emailContact= false;
            this.form.contact_name      = contact.name;
            if (contact.phone){
                this.form.contact_cell = contact.phone;
            }else {
                this.form.contact_cell = contact.cell;
            }
            this.form.contact_email     = contact.email;
        },
        finalSaveDataRequest() {
            let self = this;
            this.form.company_types_id  = this.selectedCompanyType ? this.selectedCompanyType.id : null;
            this.form.contact_types_id  = this.selectedContactType ? this.selectedContactType.id : null;

            this.form.post(route('api.company.store')).then((data) => {
                self.$refs.CompanyCustomFields.submit(data.data.id, data.foundationCustomerNo);
                if(self.foundationCustomerAccess) {
                    Swal.fire({
                        title: 'Created',
                        html: data.message.message,
                        type: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#01B1AF',
                        confirmButtonText: 'OK!',
                        closeOnConfirm: false,
                    }).then(() => {
                        self.$emit('inserted', data.data);
                    })
                }
                else {
                    self.$emit('inserted', data.data);
                }

                $('#modal-create-company').modal('hide');
            });
        }
    }
}
</script>
